
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/skihuur",
      function () {
        return require("private-next-pages/[region]/[resort]/skihuur.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/skihuur"])
      });
    }
  